export const APP_TRACE_ANNOUNCEMENT_SHOWN = 'AnnouncementCard.Shown';
export const APP_TRACE_ANNOUNCEMENT_DISMISSED = 'AnnouncementCard.Dismissed';
export const APP_TRACE_PROP_MESSAGE_VERSION = 'messageVersion';
export const APP_TRACE_PROP_PATHNAME = 'pathname';
